export default __webpack_public_path__ + "static/media/Screenshot (114).2a6d56cc.png";